const C = {
  bg: "#0a0a0a",
  text: "#f5f5f5",
  muted: "#888888",
  bordeaux: "#6d0000",
  border: "#222222",
  card: "#141414",
};

const LOGO_URL =
  "/manus-storage/logo_2d439bd1.jpg";

export default function Impressum() {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: C.bg,
        color: C.text,
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      {/* Bordeaux-Akzentlinie */}
      <div style={{ height: "4px", backgroundColor: C.bordeaux }} />

      {/* Header */}
      <header
        style={{
          padding: "16px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: `1px solid ${C.border}`,
          backgroundColor: C.bg,
        }}
      >
        <a href="/" style={{ display: "flex", alignItems: "center", gap: "12px", textDecoration: "none" }}>
          <img src={LOGO_URL} alt="WERBEAGENTUR Larissa Girenko" style={{ width: "40px", height: "40px", objectFit: "contain" }} />
          <div>
            <span
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontWeight: 700,
                fontSize: "14px",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                color: C.text,
              }}
            >
              WERBEAGENTUR Larissa Girenko
            </span>
          </div>
        </a>
        <a href="/" style={{ color: C.muted, fontSize: "13px", textDecoration: "none" }}>
          ← Zurück zur Startseite
        </a>
      </header>

      {/* Inhalt */}
      <main style={{ maxWidth: "700px", margin: "0 auto", padding: "48px 24px 80px" }}>
        <h1
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "42px",
            letterSpacing: "0.05em",
            color: C.bordeaux,
            marginBottom: "8px",
          }}
        >
          Impressum
        </h1>
        <p style={{ color: C.muted, marginBottom: "40px", fontSize: "14px" }}>
          Angaben gemäß § 5 TMG
        </p>

        {/* Angaben zur Person / Unternehmen */}
        <div
          style={{
            backgroundColor: C.card,
            padding: "24px",
            borderLeft: `3px solid ${C.bordeaux}`,
            marginBottom: "32px",
            lineHeight: 1.8,
            fontSize: "15px",
          }}
        >
          <p style={{ fontWeight: 700, fontSize: "17px", marginBottom: "12px", color: "#ffffff" }}>
            WERBEAGENTUR Larissa Girenko
          </p>
          <p>Inhaberin: Larissa Girenko</p>
          <p style={{ color: C.muted, fontSize: "13px", marginTop: "8px" }}>
            Lutherstr. 16 c<br />
            04315 Leipzig<br />
            Deutschland
          </p>
        </div>

        <Section title="Kontakt">
          <p>
            E-Mail:{" "}
            <a href="mailto:werbeagentur.lg@gmail.com" style={{ color: C.bordeaux }}>
              werbeagentur.lg@gmail.com
            </a>
          </p>
          <p style={{ marginTop: "4px" }}>
            Website:{" "}
            <a href="https://werbeagentur.me" style={{ color: C.bordeaux }}>
              werbeagentur.me
            </a>
          </p>
        </Section>

        <Section title="Umsatzsteuer">
          <p>
            Gemäß § 19 UStG wird keine Umsatzsteuer erhoben und ausgewiesen (Kleinunternehmerregelung).
          </p>
        </Section>

        <Section title="Berufsbezeichnung">
          <p>
            Berufsbezeichnung: Werbeagentur / Marketingberatung<br />
            Verliehen in: Deutschland
          </p>
        </Section>

        <Section title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
          <p>
            Larissa Girenko<br />
            Lutherstr. 16 c, 04315 Leipzig
          </p>
        </Section>

        <Section title="Haftungsausschluss">
          <SubSection title="Haftung für Inhalte">
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
          </SubSection>
          <SubSection title="Haftung für Links">
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </SubSection>
          <SubSection title="Urheberrecht">
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </SubSection>
        </Section>

        <Section title="Streitschlichtung">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={{ color: C.bordeaux }}>
              https://ec.europa.eu/consumers/odr/
            </a>
            .<br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
          <p style={{ marginTop: "8px" }}>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Section>

        <div style={{ marginTop: "48px", paddingTop: "24px", borderTop: `1px solid ${C.border}`, color: C.muted, fontSize: "13px" }}>
          <a href="/datenschutz" style={{ color: C.bordeaux, marginRight: "24px" }}>Datenschutzerklärung</a>
          <a href="/" style={{ color: C.muted }}>Zurück zur Startseite</a>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: "28px" }}>
      <h2
        style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: "20px",
          letterSpacing: "0.05em",
          color: "#ffffff",
          marginBottom: "10px",
          paddingBottom: "6px",
          borderBottom: `1px solid #222`,
        }}
      >
        {title}
      </h2>
      <div style={{ color: "#cccccc", lineHeight: 1.7, fontSize: "14px" }}>{children}</div>
    </section>
  );
}

function SubSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: "14px" }}>
      <h3 style={{ fontSize: "14px", fontWeight: 600, color: "#ffffff", marginBottom: "4px" }}>{title}</h3>
      {children}
    </div>
  );
}
